var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"layout"},[_c('Layout',[_c('Header',[_c('LayoutHeader')],1),_vm._v(" "),_c('Content',[_c('router-view')],1),_vm._v(" "),(!this.$store.state.showPay)?_c('Footer',[_c('tuifooter')],1):_vm._e()],1),_vm._v(" "),(!_vm.isMoblie)?_c('BackTop'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56e48edd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = LJGV
// module chunks = 1